import { useEffect, useState } from "react";
import type { CircularProgressProps } from "@mui/material";
import { CircularProgress as MuiCircularProgress } from "@mui/material";

const DEFAULT_DELAY = 1000;

export const CircularProgress = ({ delay = false, ...props }: { delay?: number | boolean } & CircularProgressProps) => {
  const [show, setShow] = useState(!delay);

  useEffect(() => {
    if (!delay) return;

    const timer = setTimeout(() => setShow(true), typeof delay === "number" ? delay : DEFAULT_DELAY);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!show) return null;

  return <MuiCircularProgress {...props} />;
};
